(function () {
  if (window.__fusfitFreeShippingBooted) return;
  window.__fusfitFreeShippingBooted = true;

  const FREE_SHIPPING_TARGET = 35;
  const CART_CACHE_KEY = 'fusfit-cart-cache-v1';
  const CART_CACHE_TTL = 15000;
  let cartPromise = null;
  let refreshTimer = null;

  function readCachedCart() {
    try {
      const payload = JSON.parse(window.sessionStorage.getItem(CART_CACHE_KEY) || 'null');
      if (!payload || !payload.cart || !payload.ts) return null;
      if (Date.now() - Number(payload.ts) > CART_CACHE_TTL) return null;
      return payload.cart;
    } catch (error) {
      return null;
    }
  }

  function writeCachedCart(cart) {
    try {
      window.sessionStorage.setItem(CART_CACHE_KEY, JSON.stringify({ ts: Date.now(), cart }));
    } catch (error) {
      // ignore session storage failures
    }
  }

  function fetchCart(force) {
    if (!force && cartPromise) return cartPromise;
    const cachedCart = !force ? readCachedCart() : null;
    if (cachedCart) {
      cartPromise = Promise.resolve(cachedCart);
      return cartPromise;
    }
    cartPromise = fetch(`/cart.js?_=${Date.now()}`, {
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    }).then((r) => r.ok ? r.json() : null).then((cart) => {
      if (cart) writeCachedCart(cart);
      return cart;
    }).catch(() => cachedCart || null);
    return cartPromise;
  }

  function formatUsd(value) {
    const amount = Number(value || 0);
    if (Math.abs(amount - Math.round(amount)) < 0.001) return `$${Math.round(amount)}`;
    return `$${amount.toFixed(2)}`;
  }

  function freeShippingState(cart) {
    const subtotal = Number((((cart || {}).items_subtotal_price) || 0)) / 100;
    const remaining = Math.max(FREE_SHIPPING_TARGET - subtotal, 0);
    return {
      subtotal,
      remaining,
      unlocked: remaining <= 0,
      progress: Math.max(0, Math.min(100, (subtotal / FREE_SHIPPING_TARGET) * 100))
    };
  }

  function placeCartBar(container) {
    if (!container) return;
    const divisasBlock = document.querySelector('.cart-totals .fusfit-divisas-info');
    if (divisasBlock) {
      divisasBlock.insertAdjacentElement('afterend', container);
      container.classList.add('fusfit-free-shipping-bar--cart-inline');
    }
  }

  function render(container, cart) {
    if (!container) return;
    placeCartBar(container);
    const state = freeShippingState(cart || {});
    const title = state.unlocked
      ? 'Listo, ya tienes delivery gratis'
      : state.remaining <= 5
        ? `Te faltan solo ${formatUsd(state.remaining)} para delivery gratis`
        : `Te faltan ${formatUsd(state.remaining)} para delivery gratis`;
    const detail = 'Solamente en Caracas';

    container.innerHTML = `
      <div class="fusfit-free-shipping ${state.unlocked ? 'is-complete' : ''}">
        <div class="fusfit-free-shipping__text-wrap">
          <div class="fusfit-free-shipping__title">${title}</div>
          <div class="fusfit-free-shipping__detail">${detail}</div>
        </div>
        <div class="fusfit-free-shipping__track" aria-hidden="true">
          <span class="fusfit-free-shipping__fill" style="width:${state.unlocked ? 100 : state.progress}%"></span>
        </div>
      </div>
    `;
  }

  async function refresh(force) {
    const container = document.getElementById('FusfitFreeShippingBar');
    if (!container) return null;
    const cart = await fetchCart(force);
    render(container, cart || {});
    document.dispatchEvent(new CustomEvent('fusfit:cart-updated', { detail: { cart: cart || {} } }));
    return cart;
  }

  function scheduleRefresh() {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(() => {
      cartPromise = null;
      refresh(true);
    }, 260);
  }

  function bindCartPageRefresh() {
    const cartRoot = document.querySelector('.cart-page, cart-items-component, form[action*="/cart"]');
    if (!cartRoot || cartRoot.dataset.fusfitRefreshBound === 'true') return;
    cartRoot.dataset.fusfitRefreshBound = 'true';

    const triggerRefresh = () => scheduleRefresh();
    cartRoot.addEventListener('change', triggerRefresh, true);
    cartRoot.addEventListener('submit', triggerRefresh, true);
    cartRoot.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      if (target.closest('[name="plus"], [name="minus"], [data-remove], .cart-remove-button, .quantity-button, button')) {
        triggerRefresh();
      }
    }, true);

    const observedRoot = cartRoot.querySelector('.cart-page__items') || cartRoot;
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        const target = mutation.target;
        if (!(target instanceof Node)) continue;
        if (target.parentElement?.closest('.fusfit-free-shipping-bar, #FusfitRecommendationsCart') || target instanceof Element && target.closest('.fusfit-free-shipping-bar, #FusfitRecommendationsCart')) {
          continue;
        }
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          triggerRefresh();
          break;
        }
      }
    });
    observer.observe(observedRoot, { childList: true, subtree: true, characterData: true });
  }

  function init() {
    window.__fusfitRefreshFreeShipping = () => scheduleRefresh();
    bindCartPageRefresh();
    const cachedCart = readCachedCart();
    if (cachedCart) {
      render(document.getElementById('FusfitFreeShippingBar'), cachedCart);
      document.dispatchEvent(new CustomEvent('fusfit:cart-updated', { detail: { cart: cachedCart } }));
      return;
    }
    refresh(false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
